"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.NavBtn = exports.NavLink = exports.LinkList = exports.NavContainer = exports.Wrapper = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _Layout = require("../../../../Layout");

var _Link = _interopRequireDefault(require("../../../../Link"));

var _Button = _interopRequireDefault(require("../../../../Button"));

var _MegaMenu = require("../../MegaMenu/MegaMenu.style");

var Wrapper = (0, _styled.default)('div')(function (_ref) {
  var colors = _ref.theme.colors;
  return {
    height: _MegaMenu.headerHeight,
    backgroundColor: colors.black,
    color: colors.white
  };
});
exports.Wrapper = Wrapper;
var NavContainer = (0, _styled.default)(_Layout.Container)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  height: '100%'
});
exports.NavContainer = NavContainer;
var LinkList = (0, _styled.default)('div')({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flex: '1 0 auto'
});
exports.LinkList = LinkList;
var NavLink = (0, _styled.default)(_Link.default)(function (_ref2) {
  var _ref2$theme = _ref2.theme,
      space = _ref2$theme.space,
      colors = _ref2$theme.colors,
      globalNav = _ref2$theme.globalNav,
      active = _ref2.active;
  return {
    marginRight: space.large,
    height: _MegaMenu.headerHeight,
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    span: {
      color: globalNav.secondaryLinksColor,
      // this is on purpose, see parent component for explanation
      fontWeight: active === 'true' ? 'bold' : 'normal',
      fontSize: globalNav.primaryMenuLinkFontSize,
      lineHeight: globalNav.primaryMenuLinkLineHeight
    },
    '&:hover span': {
      color: globalNav.secondaryLinksColor,
      borderBottomColor: globalNav.secondaryLinksColor
    },
    '&::before': {
      content: active === 'true' ? '""' : 'none',
      position: 'absolute',
      left: '50%',
      transform: 'translate(-50%, 0)',
      top: '0',
      width: '0',
      height: '0',
      borderLeft: '1.3rem solid transparent',
      borderRight: '1.3rem solid transparent',
      borderTop: "1.6rem solid ".concat(colors[globalNav.globalNavWrapBg])
    }
  };
});
exports.NavLink = NavLink;
var NavBtn = (0, _styled.default)(_Button.default)(function (_ref3) {
  var space = _ref3.theme.space;
  return {
    marginRight: space.large
  };
});
exports.NavBtn = NavBtn;